import React from 'react';
import { useWatch } from 'react-hook-form';
import { CommentIcon } from 'components/icons';
import IconButton from 'components/shared/IconButton';
import { ProgressIndicator } from 'components/shared/Progress';
import { DeviceChartSet } from 'components/features/DeviceChartView';
import styles from './ChartExplorerPageChartView.module.css';

const classes = {
  row: styles.row,
  item: styles.item,
  body: styles.deviceChartBody,
  errorRoot: styles.errorRoot,
  container: styles.cardContainer,
  item_placeholder: styles.item_placeholder,
  placeholderContainer: styles.placeholderContainer
};

const ChartExplorerPageChartView = ({
  onSelect,
  onCreate,
  onUpdate,
  onManage,
  onEditChart,
  onDeleteChart,
  loading,
  enabledMarker
}) => {
  const { isPlacingMarker, placeMarker, resetMarker } = DeviceChartSet.useContext();
  const devices = useWatch({ name: 'state.query.devices' });
  const disabled = !devices || devices.length === 0;

  return (
    <div className={styles.container}>
      {loading && !disabled && <ProgressIndicator />}
      <DeviceChartSet.Console
        header={
          <DeviceChartSet.Header
            onCreate={onCreate}
            onUpdate={onUpdate}
            onSelect={onSelect}
            onManage={onManage}
            disabled={disabled}
            controls={
              enabledMarker ? (
                <IconButton
                  size="small"
                  aria-label="Mark"
                  aria-pressed={isPlacingMarker}
                  data-tip={isPlacingMarker ? 'Cancel Chart Marker' : 'Place Chart Marker'}
                  className={styles.placeMarker}
                  onClick={isPlacingMarker ? resetMarker : placeMarker}
                >
                  <CommentIcon size="medium" />
                </IconButton>
              ) : null
            }
          />
        }
      >
        <DeviceChartSet.Body classes={classes} onEdit={onEditChart} onDelete={onDeleteChart} disabled={disabled} />
      </DeviceChartSet.Console>
    </div>
  );
};

export default ChartExplorerPageChartView;
